<template>
    <div id="loginDialog">
        <div class="login-qrcode">
            <div class="title">
                <img src="../images/wx-icon.png" />
                <span>微信登录</span>
            </div>
            <div class="qrcode-box">
                <img
                    v-show="wxminiQrcode"
                    :src="wxminiQrcode"
                    :style="`opacity: ${isQrcodeRestart ? '0.2' : '1'}`"
                    class="wx-qrcode"
                />
                <canvas
                    v-show="!wxminiQrcode"
                    :style="`opacity: ${isQrcodeRestart ? '0.2' : '1'}`"
                    class="wx-qrcode"
                    ref="wxQrcode"
                ></canvas>
                <button @click.stop="getWxMpLoginQRCodeApi" v-show="isQrcodeRestart" class="restart-btn">
                    刷新二维码
                </button>
            </div>
            <div class="sub-title">请使用微信扫描二维码</div>
        </div>
    </div>
</template>
<script>
import { getOAuthTpTicket, userLogin } from '@/utils/api.js'
import { setUserInfo } from '@/utils/login.js'
import { urlQuery } from '@/utils/utils.js'
const QRCode = require('qrcode')

let timer = null
export default {
    props: ['goodDialogStatus'],
    data() {
        return {
            isQrcodeRestart: false,
            wxminiQrcode: '',
        }
    },
    mounted() {
        this.getWxMpLoginQRCodeApi()
    },
    methods: {
        getWxMpLoginQRCodeApi() {
            this.isQrcodeRestart = false
            const query = urlQuery()
            let params = { type: 'OAUTH_H5' }
            if (query.wxmini) {
                params = { type: 'OAUTH_WXMA', appId: 'wx93ad102e24de3ea8' }
            }
            getOAuthTpTicket(params).then(res => {
                if (params.type === 'OAUTH_H5') {
                    QRCode.toCanvas(
                        this.$refs.wxQrcode,
                        res.data.authUrl,
                        { width: 260, height: 260, margin: 2, errorCorrectionLevel: 'L' },
                        () => {}
                    )
                } else {
                    this.wxminiQrcode = res.data.qrcodeUrl
                }
                let timeNum = 0
                clearInterval(timer)
                timer = setInterval(() => {
                    userLogin({ type: 'auth_ticket', authTicket: res.data.tpTicket }).then(u => {
                        const userInfo = u.data
                        if (userInfo) {
                            clearInterval(timer)
                            setUserInfo(userInfo)
                            this.$emit('authSuccess', userInfo)
                        }
                    })
                    timeNum += 3
                    if (timeNum >= 5 * 60) {
                        clearInterval(timer)
                        this.isQrcodeRestart = true
                        this.$toast('二维码已过期')
                    }
                }, 3000)
            })
        },
    },
}
</script>

<style lang="scss">
#loginDialog {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba($color: #000000, $alpha: 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99;
    .login-qrcode {
        width: 300px;
        height: 360px;
        border-radius: 10px;
        background: #fff;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.1);
    }
    .title {
        display: flex;
        align-items: center;
        font-size: 18px;
        font-weight: 700;
        height: 50px;
        padding-left: 30px;
        border-bottom: 2px solid #eee;
        img {
            width: 30px;
            height: 30px;
            margin-right: 10px;
        }
    }
    .qrcode-box {
        width: 260px;
        height: 260px;
        position: relative;
        margin: 10px auto 0;
        .wx-qrcode {
            width: 260px;
            height: 260px;
        }
    }
    .restart-btn {
        font-size: 14px;
        border: none;
        background: #666;
        color: #fff;
        line-height: 30px;
        width: 120px;
        border-radius: 4px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        cursor: pointer;
    }
    .qrcode {
        width: 260px;
        height: 260px;
    }
    .sub-title {
        font-size: 14px;
        color: #aaa;
        text-align: center;
        line-height: 1.4em;
    }
    .sub-title-color {
        color: #555;
        font-weight: 700;
    }
}
</style>
